const actionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SET_PRODUCT_TO_DISPLAY: "SET_PRODUCT_TO_DISPLAY",
    ADD_TO_CART:'ADD_TO_CART',
    REMOVE_FROM_CART:'REMOVE_FROM_CART',
    REMOVE_ITEM_FROM_CART: 'REMOVE_ITEM_FROM_CART',
    UPDATE_CART_VALUES:'UPDATE_CART_VALUES',
    CLEAR_CART:'CLEAR_CART',
    MODAL_OPEN:'MODAL_OPEN',
    MODAL_CLOSE:'MODAL_CLOSE',
    SET_ALERT: 'SET_ALERT'
};

export default actionTypes;
